module.exports = "/static/assets/fd33cf9a4c8a05840c63e59fed32e1aa.png";